import React from 'react';
import { Box } from '@mui/system';
import { Card } from '@mui/material';
import { styles } from './error-helpers';
import NotFoundSvg from '../../assets/images/404-error.png';

export const NotFoundError = (): React.JSX.Element => {
    return (
        <Box sx={styles.mainContainer}>
            <Card sx={styles.cardContainer}>
                <img
                    src={NotFoundSvg}
                    alt='page not found'
                    style={styles.notFoundImage}
                />
            </Card>
        </Box>
    );
};
